<template>
  <div id="accountUnlock">
    <el-card
      :style="{width: dialogWidth}"
      shadow="hover"
      class="defaultCursor"
    >
      <div
        v-if="!error"
        class="title"
      >
        {{ $t('account.unlocked.title') }}
      </div>

      <div class="details">
        <span v-if="!error">
          {{ $t('account.unlocked.redirect', {countDown: countDown}) }}
        </span>
        <span v-else>
          {{ $t('account.unlocked.failed') }}
        </span>
      </div>
    </el-card>
  </div>
</template>

<script>
import api from '@/api';
import DialogSetting from '@/mixins/dialog';

export default {
  mixins: [DialogSetting],

  data() {
    return {
      isUnlocked: false,
      countDown: 5,
      error: false,
    };
  },

  created() {
    this.unlockAccount();
  },

  methods: {
    async unlockAccount() {
      try {
        const { uid64, token } = this.$route.params;
        await api.accountUnlock(uid64, token);
        this.countDownTimer();
        setTimeout(() => {
          this.$router.push({ name: 'login' });
        }, 5000);
      } catch (err) {
        console.log(err);
        if (err.msg) {
          if (err.msg.includes('Failed')) {
            this.$message.error(err.msg);
            this.error = true;
          } else {
            this.countDownTimer();
            setTimeout(() => {
              this.$router.push({ name: 'login' });
            }, 5000);
          }
        }
      }
    },

    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#accountUnlock {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 5px;

  .el-card {
    // width: 55%;
    max-width: 600px;
    margin: auto;
    text-align: center;

    .title {
      font-weight: bold;
      margin-bottom: 20px;
    }
  }
}
</style>
